import { createStore } from 'vuex';

// Declare empty store first, dynamically register all modules later.
export default createStore({});
